// src/components/SubDashboard.jsx
export function SubDashboard({ title, subtitle, cards, setPage, countMap = {}, showBack = true }) {
  return (
    <>
      {showBack && (
        <button className="btn" style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 6 }}
          onClick={() => setPage("home")}>
          ← Home
        </button>
      )}
      <div className="page-header">
        <div className="page-header-left">
          <div className="page-title">{title}</div>
          <div className="page-subtitle">{subtitle}</div>
        </div>
      </div>
      <div className="home-grid">
        {cards.map(c => (
          <div key={c.id} className="home-card"
            onClick={() => !c.disabled && (c.href ? window.open(c.href, "_blank", "noopener") : setPage(c.id))}
            style={{
              background: c.disabled
                ? "#f8f8f8"
                : `linear-gradient(145deg, rgba(255,255,255,0.93) 0%, ${c.accent}0e 100%)`,
              border: `1px solid ${c.disabled ? "#e5e7eb" : "rgba(255,255,255,0.72)"}`,
              boxShadow: c.disabled
                ? "0 1px 4px rgba(0,0,0,0.04)"
                : `0 2px 16px ${c.accent}1a, inset 0 1.5px 0 rgba(255,255,255,0.95)`,
              cursor:  c.disabled ? "default" : "pointer",
              opacity: c.disabled ? 0.75 : 1,
            }}>
            <div className="home-card-icon" style={{ filter: c.disabled ? "grayscale(0.6)" : "none" }}>
              {c.icon}
            </div>
            <div className="home-card-label" style={{ color: c.disabled ? "#999" : c.accent }}>
              {c.label}
            </div>
            <div className="home-card-count" style={{ color: c.disabled ? "#bbb" : undefined }}>
              {c.disabled
                ? <span style={{ fontSize: 10, fontWeight: 600, textTransform: "uppercase",
                    letterSpacing: ".05em", color: "#bbb" }}>Coming soon</span>
                : countMap[c.id] != null
                  ? `${countMap[c.id]} item${countMap[c.id] !== 1 ? "s" : ""}`
                  : c.desc
              }
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
